export default {
	chatURL: '/chat',
	socketStatuses: {
		offline: 'grey',
		online: 'green',
		errored: 'red',
		connecting: 'orange',
	},
	socketStatus: 'offline',
	joinDMChar: '-',
	dateFormat: 'YYYY-MM-DD HH:mm:ss',
	humanDateFormat: 'DD/MM/YYYY HH:mm:ss',
	messagesPerPacket: 20,
};
export const MAX_PREVIEW_SIZE = 2_097_152; // 2mb
